export default __webpack_public_path__ + "static/media/grafema_pilates_11.2136d72a.jpg";